var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-usable-dropdown',{attrs:{"value":_vm.value,"nameFields":['name'],"items":_vm.paidOptions},on:{"onSelected":_vm.onSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }